import React from "react";
import { Upload, Button, Card, Col, Row, Icon } from "antd";
import { Field, FieldArray } from "formik";
import uuid from "uuid/v4";
import { DescripcionComponent, TituloComponent } from "../FormHelpers";

const fileList = [
  {
    uid: "-1",
    name: "xxx.png",
    status: "done",
    url:
      "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    thumbUrl:
      "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
  },
  {
    uid: "-2",
    name: "yyy.png",
    status: "done",
    url:
      "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
    thumbUrl:
      "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png"
  }
];

const props3 = {
  action: "//jsonplaceholder.typicode.com/posts/",
  listType: "picture",
  defaultFileList: [...fileList]
};

const props2 = {
  action: "//jsonplaceholder.typicode.com/posts/",
  listType: "picture",
  defaultFileList: [...fileList],
  className: "upload-list-inline"
};

export const UploadComponent = ({ field, ...props }) => {
  return (
    <Upload {...props3} {...props} {...field}>
      <Button>
        <Icon type="upload" /> Upload
      </Button>
    </Upload>
  );
};

const CustomUploadArray = ({ actividadIndex, etapaIndex, values }) => {
  const ref = values.etapas[etapaIndex].actividades[actividadIndex].upload || [
    {
      key: uuid(),
      uploadTitle: "Titulo",
      uploadDescription: "Descripcion casilla"
    }
  ];
  return (
    <FieldArray
      name={`etapas.${etapaIndex}.actividades.${actividadIndex}.upload`}
      render={helpers => (
        <Card style={{ background: "#F3E5F5" }}>
          {ref.map((upload, uploadIndex) => (
            <Row key={uploadIndex} type="flex" align="middle">
              <Col span={22}>
                <div>Sube una imagen o video</div>
                <Field
                  name={`etapas.${etapaIndex}.actividades.${actividadIndex}.upload.${uploadIndex}.uploadTitle`}
                  component={TituloComponent}
                />
                <Field
                  name={`etapas.${etapaIndex}.actividades.${actividadIndex}.upload.${uploadIndex}.uploadDescription`}
                  component={DescripcionComponent}
                />
              </Col>

              <Col span={2}>
                <Button
                  type="button"
                  onClick={() => helpers.remove(uploadIndex)}
                >
                  -
                </Button>
              </Col>
            </Row>
          ))}
          <Button type="button" onClick={() => helpers.push({ key: uuid() })}>
            +
          </Button>
        </Card>
      )}
    />
  );
};

export default CustomUploadArray;
